import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';
import { HostListener } from '@angular/core';


import jspreadsheet from "jspreadsheet";
import "jspreadsheet/dist/jspreadsheet.css"
import "jsuites/dist/jsuites.css"
import { title } from 'process';
import { FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';
import { removeResize } from '@syncfusion/ej2-popups/src/common/resize';

@Component({
  selector: 'app-listpricesspreadsheet',
  templateUrl: './listpricesspreadsheet.component.html',
  styleUrls: ['./listpricesspreadsheet.component.css']
})
export class ListpricesspreadsheetComponent implements OnInit {


  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length > 2){
          this.SplitGetIndustryProductsSearchQuery(value);
        }
      });
  }

  searchTermUpdate = new Subject<string>();
  CurrentCartItemRow:any;

  ngOnInit(): void {
    this.InitializeFilter();
    this.CartItemRows = [];
    const SearchProductsPageMessage = this.cookieService.get('SearchProductsPageMessage');

    if(SearchProductsPageMessage?.length > 0){
      this.ShowSearchProductsPageMessage = false;
    }
    else{
      this.GetB2BHomePageMessage();
    }

    this.PopulateCartItems(50);
  }

  Filter: {[k: string]: any} = {};

InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.Brand = {};
  this.Filter.Brand = null;

  this.Filter.ProductBoxStatus = {};
  this.Filter.ProductBoxStatus = null;

  this.Filter.ProductConditionStatus = {};
  this.Filter.ProductConditionStatus = null;

  this.Filter.ProductManufacturingStatus = {};
  this.Filter.ProductManufacturingStatus = null;

  this.Filter.ProductVersionStatus = {};
  this.Filter.ProductVersionStatus = null;

  this.Filter.Creator = {};
  this.Filter.Creator = null;

  this.Filter.Updater = {};
  this.Filter.Updater = null;

  this.Filter.CombineProductsByID = true;
}



ShowSearchProductsPageMessage:boolean;

loadingProducts:boolean;
SearchedProducts:any[];
CartItemRows: {[k: string]: any} = [];

InitializeSearchProduct(item:any){

  this.CurrentCartItemRow = item;
  this.SelectItem(item);

  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.SearchIndustryProducts();
  }
}

OfferPriorityStatuses:any[];
OfferPriorityStatus:any;

PopulateCartItems(rows = 50){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Rows:rows
  };

  this.loadingProducts = true;

  this.B2BService.PopulateCartItems(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var CI = JSON.parse(JSON.stringify(response["CartItems"]));
      this.CartItemRows = this.CartItemRows.concat(CI);

      if(this.OfferPriorityStatuses == null || this.OfferPriorityStatuses?.length == 0){
        this.OfferPriorityStatuses = response["OfferPriorityStatuses"];
        this.OfferPriorityStatus = this.OfferPriorityStatuses[0];
      }
    }

    this.loadingProducts = false;
   });
}

GetIndustryProductsStocksFiltered(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["StockProducts"];
    }

    this.loadingProducts = false;
   });
}

AllSelected:boolean;

SelectAll(){
  this.parent.Cart.Items.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.parent.Cart.Items.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SearchIndustryProducts(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.SearchIndustryProducts(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["SearchResults"];
    }

    this.loadingProducts = false;
   });
}

SelectItem(i:any){
  this.CartItemRows.forEach(cell => {
    if(cell.UIID == i.UIID){
      cell.IsSelected = !cell.IsSelected;
    }
    else{
      cell.IsSelected = false;
    }
  });
}

SplitGetIndustryProductsSearchQuery(searchQuery:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchQuery:searchQuery,
    UIID:this.CurrentCartItemRow.UIID,
    CartItems:this.CartItemRows,
    Partner:this.parent.B2BPartner
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == this.CurrentCartItemRow.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SplitGetIndustryProductsSearchQuery(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CartItemRows = [];
      this.CartItemRows = JSON.parse(JSON.stringify(response["CartItems"]));

      this.CartItemRows.filter(x => !x.WasSearchedFor && x.UIProductValue?.length > 0).forEach(cell => {
        this.SearchIndustryProductsFromGridCell(cell);
      });
    }

    this.searchTermUpdate.next(null);
   });
}

SearchIndustryProductsFromGridCell(item:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    UIID:item.UIID,
    CartItem:item,
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SearchIndustryProductsFromGridCell(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["CartItem"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
            this.GetGridCellItemData(JSON.parse(JSON.stringify(this.CartItemRows[index])));
        }
      });
    }

    this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = false;
      }
    });

    this.searchTermUpdate.next(null);
   });
}

SelectGridSearchResult(s:any, item:any){

  item.SearchResults.forEach(element => {
    element.IsSelected = false;
  });

  // Find the index of the matching search result
const index = item.SearchResults.findIndex(searchResult => searchResult.UIID === s.UIID);

// If a matching search result is found
if (index !== -1) {
    // Set isSelected to true
    item.SearchResults[index].IsSelected = true;

    // Move the matching search result to the beginning of the array
    const selectedSearchResult = item.SearchResults.splice(index, 1)[0];
    item.SearchResults.unshift(selectedSearchResult);
}

  this.GetGridCellItemData(JSON.parse(JSON.stringify(item)));
  item.IsSelected = false;
}

GetGridCellItemData(c:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    newItem:c,
    Partner:this.parent.B2BPartner
  };

  this.B2BService.GetGridCellItemDataWithDBLevelCalculation(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["Item"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == c.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
        }
    });
    }
   });
}

ExportB2BGrid(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CartItems:this.CartItemRows,
  };

  this.parent.loading = true;

  this.B2BService.ExportB2BGrid(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }
   });

   this.parent.loading = false;
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.parent.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

CloseShowSearchProductsPageMessage(){
  this.cookieService.set("SearchProductsPageMessage", "true");
  this.ShowSearchProductsPageMessage = false;
}

B2BHomePageMessage:string;

GetB2BHomePageMessage(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.parent.B2BPartner,
    Agent:this.parent.B2BAgent
  };

  this.loadingProducts = true;

  this.B2BService.GetB2BHomePageMessage(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowSearchProductsPageMessage = true;
      this.B2BHomePageMessage = response["B2BHomePageMessage"];
      this.GetB2BListedBrands();
    }

    this.loadingProducts = false;
   });
}

Brands:any[];
loadingBrandIcons:boolean = false;

GetB2BListedBrands(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.loadingBrandIcons = true;

  this.B2BService.GetB2BListedBrands(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Brands = JSON.parse(JSON.stringify(response["Brands"]));
    }

    this.loadingBrandIcons = false;
   });
}


  data = [
    ['Row 1, Cell 1', 'Row 1, Cell 2', 'Row 1, Cell 3'],
    ['Row 2, Cell 1', 'Row 2, Cell 2', 'Row 2, Cell 3'],
    ['Row 3, Cell 1', 'Row 3, Cell 2', 'Row 3, Cell 3']
  ];

  selectedCells: Set<string> = new Set();
  clipboardData: string[][] = [];

  selectCell(event: MouseEvent, rowIndex: number, colIndex: number) {
    const cell = event.target as HTMLElement;
    const cellKey = `${rowIndex}-${colIndex}`;
    
    if (event.ctrlKey || event.metaKey) {
      if (this.selectedCells.has(cellKey)) {
        this.selectedCells.delete(cellKey);
        cell.classList.remove('selected');
      } else {
        this.selectedCells.add(cellKey);
        cell.classList.add('selected');
      }
    } else {
      this.clearSelections();
      this.selectedCells.add(cellKey);
      cell.classList.add('selected');
    }
  }

  clearSelections() {
    document.querySelectorAll('td').forEach(cell => {
      cell.classList.remove('selected');
    });
    this.selectedCells.clear();
  }

  updateCell(event: any, rowIndex: number, colIndex: number) {
    this.data[rowIndex][colIndex] = event.target.textContent;
  }

  // Capture Ctrl+C for copying
  @HostListener('document:keydown.control.c', ['$event'])
  copy(event: KeyboardEvent) {
    const selectedData = Array.from(this.selectedCells).map(key => {
      const [rowIndex, colIndex] = key.split('-').map(Number);
      return this.data[rowIndex][colIndex];
    });
    this.clipboardData = [selectedData];
  }

  // Capture Ctrl+V for pasting
  @HostListener('document:keydown.control.v', ['$event'])
  paste(event: KeyboardEvent) {
    if (this.clipboardData.length > 0 && this.selectedCells.size > 0) {
      this.selectedCells.forEach(key => {
        const [rowIndex, colIndex] = key.split('-').map(Number);
        this.data[rowIndex][colIndex] = this.clipboardData[0][0]; // Simple paste
      });
    }
  }

}
